import PreviewLink from './component.styles'
export default PreviewLink
